import { Dispatch, SetStateAction, useState } from "react";
import TextField from "@mui/material/TextField";
import CloseIcon from "@mui/icons-material/Close";
import {
    Modal,
    Button,
    Select,
    MenuItem,
    SelectChangeEvent,
    Checkbox,
    ListItemText,
} from "@mui/material";

interface ModalProps {
    open: boolean;
    onClose: () => void;
    setOpen: Dispatch<SetStateAction<boolean>>;
}
const usersList = [
    "Arjun Mehta",
    "Neha Sharma",
    "Rohit Verma",
    "Ananya Gupta",
    "Karan Singh",
    "Pooja Patel",
];


export default function BulkNotify({ open, onClose, setOpen }: ModalProps) {
    const [selectedUsers, setSelectedUsers] = useState<string[]>([]);
    const [message, setMessage] = useState("");

    const handleUsersChange = (event: SelectChangeEvent<string[]>) => {
        const value = event.target.value;
        setSelectedUsers(typeof value === "string" ? value.split(",") : value);
    };

    return (
        <Modal className="modal rejectReason_modal" open={open} onClose={onClose}>
            <div className="modal-dialog take_action_modal">
                <div className="modal-body">
                    {/* Header */}
                    <div className="modal_title">
                        <h2>Bulk Notify</h2>
                        <button
                            type="button"
                            className="btn-close"
                            onClick={() => setOpen(false)}
                        >
                            <CloseIcon />
                        </button>
                    </div>

                    {/* Form */}
                    <form className="form">
                        <div className="gap_p">
                            <div className="control_group">
                                <label htmlFor="bulk-notify-users">Select Users</label>
                                <Select
                                    multiple
                                    fullWidth
                                    value={selectedUsers}
                                    onChange={handleUsersChange}
                                    renderValue={(selected) =>
                                        (selected as string[]).join(", ")
                                    }
                                    inputProps={{ id: "bulk-notify-users" }}
                                >
                                    {usersList.map((user) => (
                                        <MenuItem key={user} value={user}>
                                            <Checkbox
                                                checked={
                                                    selectedUsers.indexOf(user) > -1
                                                }
                                            />
                                            <ListItemText primary={user} />
                                        </MenuItem>
                                    ))}
                                </Select>
                            </div>

                            {/* Message */}
                            <div className="control_group">
                                <label htmlFor="bulk-notify-message">Message</label>
                                <TextField
                                    placeholder="Enter notification message here..."
                                    multiline
                                    rows={5}
                                    fullWidth
                                    value={message}
                                    onChange={(e) => setMessage(e.target.value)}
                                    hiddenLabel
                                    inputProps={{ id: "bulk-notify-message" }}
                                />
                            </div>
                        </div>
                        {/* Footer */}
                        <div className="footer_btn_flex">
                            <Button
                                className="btn btn_grey"
                                onClick={() => setOpen(false)}
                            >
                                Cancel
                            </Button>
                            <Button
                                className="btn btn_primary"
                                onClick={() => setOpen(false)}
                            >
                                Send
                            </Button>
                        </div>

                    </form>
                </div>
            </div>
        </Modal>
    );
}
